import VoidScreen from "./voidScreen";
export default VoidScreen;
